import moment from 'moment'
import React from 'react'

import Divider from 'main/components/common/Divider'
import Section from 'main/components/common/Section'
import { BankIcon, CreditCardIcon, palette, spacing, Tag, Text, Title } from 'main/ui'

import { PaymentMethods_paymentMethodPending as IPaymentMethodPending } from 'main/gql/paymentMethod'

import { PaymentMethodPendingVerificationType } from 'main/gql/globalTypes'
import { CARD } from 'main/gql/paymentMethod'

import {
  ButtonContainer,
  DetailContainer,
  IconContainer,
  InfoContainer,
  TagContainer,
  VerificationContainer,
} from './PaymentMethod.styles'
import VerifyButton from './VerifyButton'

const DATE_EXP_FORMAT = 'MM/YY'

interface IProps {
  name: string
  last4: string | null
  type?: string | null
  brand?: string | null
  expMonth?: number | null
  expYear?: number | null
  paymentMethodPending?: IPaymentMethodPending
}

export default function PaymentMethod(props: IProps) {
  const { name, last4, type, brand, expMonth, expYear, paymentMethodPending } = props
  const isCreditCard = type === CARD

  return (
    <Section>
      <Title kind="section">{name}</Title>
      <DetailContainer>
        <IconContainer>{isCreditCard ? <CreditCardIcon /> : <BankIcon />}</IconContainer>
        <InfoContainer>
          <Text muted>
            {isCreditCard
              ? `${brand} ending in ${last4 || '****'} \xa0 \xa0 exp ${formatExpiration(
                  expMonth,
                  expYear,
                )}`
              : `Bank account ending in ${last4 || '****'}`}
          </Text>
        </InfoContainer>
      </DetailContainer>

      {paymentMethodPending && <Divider margin={spacing.minorScale(5)} />}

      {paymentMethodPending &&
        paymentMethodPending.verificationType ===
          PaymentMethodPendingVerificationType.AUTOMATIC && (
          <VerificationContainer>
            <TagContainer>
              <Tag color={palette.lavender2}>pending verification</Tag>
            </TagContainer>
            <Text muted>
              We are waiting for the final verification step to finish adding the payment method.
            </Text>
            <Text muted>
              Automatic account verification should complete within 2-3 business days.
            </Text>
          </VerificationContainer>
        )}

      {paymentMethodPending &&
        paymentMethodPending.verificationType === PaymentMethodPendingVerificationType.MANUAL && (
          <VerificationContainer>
            <TagContainer>
              <Tag color={palette.tangerine2}>needs attention</Tag>
            </TagContainer>
            <Text muted>
              Two deposits in the range of $0.01 - $0.99 will appear in your account within 2-3
              business days.
            </Text>
            <Text muted>
              Please return to this page to complete the verification with the deposit information.
            </Text>
            <ButtonContainer>
              <VerifyButton paymentMethodPending={paymentMethodPending}>Verify</VerifyButton>
            </ButtonContainer>
          </VerificationContainer>
        )}
    </Section>
  )
}

function formatExpiration(expMonth: number | null | undefined, expYear: number | null | undefined) {
  if (typeof expMonth !== 'number' || typeof expYear !== 'number') return 'n/a'

  const zeroIndexedExpMonth = expMonth - 1
  const dateMoment = moment().set({ month: zeroIndexedExpMonth, year: expYear })

  return dateMoment.isValid() ? dateMoment.format(DATE_EXP_FORMAT) : 'n/a'
}
